import { render } from "./CookieBox.vue?vue&type=template&id=13dd4ec4&scoped=true"
import script from "./CookieBox.vue?vue&type=script&lang=js"
export * from "./CookieBox.vue?vue&type=script&lang=js"

import "./CookieBox.vue?vue&type=style&index=0&id=13dd4ec4&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/luxgenVueLifeFrontend/home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13dd4ec4"]])

export default __exports__